module.exports = __webpack_public_path__ + "static/img/pinggu-04.c200a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pinggu-04.png
// module id = ww9e
// module chunks = 1